/** Development-only switches that Vite can erase from production bundles. */
export const DEMO = import.meta.env.DEV && import.meta.env.VITE_DEMO === '1';
